import { render, staticRenderFns } from "./PowerOfAttorneyTwoSignatories.vue?vue&type=template&id=31555b32&scoped=true&"
import script from "./PowerOfAttorneyTwoSignatories.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyTwoSignatories.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyTwoSignatories.vue?vue&type=style&index=0&id=31555b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31555b32",
  null
  
)

export default component.exports